import React, { useEffect, useState } from "react";
import { Badge, Group, Loader, Table, Text, Title } from "@mantine/core";
import { useServerApi } from "../hooks/userServerApi";
import moment from "moment";

const AccountingJournalSection = ({ sourceType, sourceId, title = "Accounting" }) => {
  const [api] = useServerApi();
  const [loading, setLoading] = useState(false);
  const [journalEntries, setJournalEntries] = useState([]);

  useEffect(() => {
    const load = async () => {
      if (!sourceType || !sourceId) return;
      setLoading(true);
      try {
        const data = await api.Accounting.getJournalsBySource(sourceType, sourceId);
        setJournalEntries(data?.journalEntries || []);
      } finally {
        setLoading(false);
      }
    };
    load();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sourceId, sourceType]);

  if (!sourceType || !sourceId) return null;

  return (
    <>
      <Title order={5} mb="sm">
        {title}
      </Title>
      {loading ? (
        <Loader size="sm" />
      ) : journalEntries.length === 0 ? (
        <Text size="sm" color="dimmed">
          No journal entries linked to this document.
        </Text>
      ) : (
        journalEntries.map((entry) => (
          <Table key={entry._id} striped withBorder mb="md" fontSize="xs">
            <thead>
              <tr>
                <th colSpan={5}>
                  <Group position="apart">
                    <Text size="sm" weight={600}>
                      {entry.code} — {moment(entry.entryDate).format("LL")}
                    </Text>
                    <Badge>{entry.status}</Badge>
                  </Group>
                </th>
              </tr>
              <tr>
                <th>Account</th>
                <th>Description</th>
                <th>Debit</th>
                <th>Credit</th>
              </tr>
            </thead>
            <tbody>
              {(entry.lines || []).map((line, index) => (
                <tr key={`${entry._id}-${index}`}>
                  <td>
                    {line.accountCode} {line.accountName}
                  </td>
                  <td>{line.description}</td>
                  <td>{line.debit || ""}</td>
                  <td>{line.credit || ""}</td>
                </tr>
              ))}
            </tbody>
          </Table>
        ))
      )}
    </>
  );
};

export default AccountingJournalSection;
